import Image from 'next/image'

interface FlagIconProps {
  code: string
  size?: number
  className?: string
}

export default function FlagIcon({ code, size = 20, className = '' }: FlagIconProps) {
  const h = Math.round(size * 0.75)
  return (
    <Image
      src={`/flags/${code.toLowerCase()}.svg`}
      alt={code.toUpperCase()}
      width={size}
      height={h}
      className={`country-flag ${className}`}
      unoptimized
    />
  )
}
